
export const SignInResultType = {
    WrongCredentials: 0,
    NeedsPasswordReset: 1,
    AccountNeedsConfirmation: 2,
    AccountInactivated: 3,
    LockedOut: 4,
    Exception: 5,
    Success: 6,
    NoRoles: 7,
    NeedsToRegister: 8,
    InvalidSocialUserName: 9
};


export const RegisterResultType = {
    InvalidPromoCode: 0,
    PromoCodeDoesNotExist: 1,
    PromoCodeExpired: 2,
    PromoCodeAlreadyUsed: 3,
    EmailAlreadyExists: 4,
    InvalidEmailProvider: 5,
    ErrorAddingUser: 6,
    NotAgreedToTerms: 7,
    SocialUserNotFound: 8,
    InvalidProvider: 9,
    Success: 999
};

export const EmailValidation = {
    Production: /^(?![-.])[a-zA-Z0-9._-]+@(?![A-Za-z0-9_\-.]+\.com\.com)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
    Lower: /^(?![-.])[a-zA-Z0-9+._-]+@(?![A-Za-z0-9_\-.]+\.com\.com)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
}
